const PRICE_PER_SEAT = 15

document.querySelectorAll("[data-seat-estimator]").forEach((widget) => {
  const slider = widget.querySelector("[data-seat-slider]")
  const countEl = widget.querySelector("[data-seat-count]")
  const costEl = widget.querySelector("[data-seat-cost]")
  if (!slider) return

  const update = () => {
    const seats = Number.parseInt(slider.value, 10)
    countEl.textContent = seats
    costEl.textContent = seats * PRICE_PER_SEAT
  }

  slider.addEventListener("input", update)
  update()
})
